<p-toast position="top-right"></p-toast>

<partner-finance-transaction-detail *ngIf="showPartnerFinanceTransactionDetailSideBar"
                                    [_showPartnerFinanceTransactionDetailSideBar]="showPartnerFinanceTransactionDetailSideBar"
                                    [_transactionId]="transactionId"
                                    (changedShowPartnerFinanceTransactionDetailSideBarEmit)="changedShowPartnerFinanceTransactionDetailSideBarEmit($event)"></partner-finance-transaction-detail>

<partner-finance-transaction-filter *ngIf="visiblePartnerFinanceTransactionFilter"
                                    [visiblePartnerFinanceTransactionFilter]="visiblePartnerFinanceTransactionFilter"
                                    [partnerFinanceTransactionsComponent]="this"
                                    [_filterObj]="filterObj"
                                    (changedShowPartnerFinanceTransactionFilterSideBarEmit)="changedShowPartnerFinanceTransactionFilterSideBarEmit($event)"></partner-finance-transaction-filter>

<!-- Table -->
<p-table #transactionsGrid
         [columns]="transactionCols"
         [value]="transactions"
         [lazy]="true"
         responsiveLayout="scroll" dataKey="Id"
         (onLazyLoad)="handleTranzactionLazyLoad($event)"
         [paginator]="true"
         [(first)]="first"
         [rows]="rowsPerPage"
         [rowsPerPageOptions]="rowsPerPageOptions"
         [totalRecords]="totalRecords"
         [resizableColumns]="true"
         [columnResizeMode]="'expand'"
         [autoLayout]="true"
         [styleClass]="'p-datatable-gridlines'"
         [scrollable]="true"
         [scrollHeight]="'flex'">
    <ng-template pTemplate="caption">
        <div class="flex flex-row sp-header">
            <div class="sp-header__col-left">
                <div class="sp-header__title">All Transactions</div>
            </div>
            <div class="flex flex row sp-header__col-right">
                <div>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" class="search-input"
                               [(ngModel)]="filter.searchName" (input)="handleFilterChange()"
                               placeholder="Search here..." />
                    </span>
                </div>
                <div class="ml-20">
                    <button class="white-btn-filter" pButton label="Filter" (click)="openPartnerFinanceTransactionFilterSideBar()"></button>
                </div>
                <div class="ml-20">
                    <button class="bluedark-btn-filter" pButton label="Export Data"></button>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th *ngFor="let col of transactionCols"
                [pSortableColumn]="col.field"
                [pSortableColumnDisabled]="col.disableSort"
                pResizableColumn
                [style.width]="col.width">
                {{col.header}}
                <p-sortIcon *ngIf="sortField===col.field" [field]="col.field"></p-sortIcon>
            </th>
            <th>Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-transaction>
        <tr [pSelectableRow]="transaction">
            <td class="ui-resizable-column">
                <span class="ui-resizable-column__link-id" (click)="openPartnerFinanceTransactionDetailSideBar(transaction.Id)">{{transaction.Id}}</span>
            </td>
            <td class="ui-resizable-column">{{transaction.CreatedAt}}</td>
            <td class="ui-resizable-column">{{transaction.Time}}</td>
            <td class="ui-resizable-column">{{transaction.CustomerName}}</td>
            <td class="ui-resizable-column">{{transaction.Spend}}</td>
            <td class="ui-resizable-column">{{transaction.ServiceText}}</td>
            <td class="ui-resizable-column">{{transaction.StatusText}}</td>
            <td>
                <span class="action-icon-svg" (click)="openPartnerFinanceTransactionDetailSideBar(transaction.Id)">
                    <img src="../Content/xpress-app/images/svg/icon_view.svg" />
                </span>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="paginatorleft" let-state>
        <div *ngIf="transactions !== null && transactions.length > 0" style="padding-left: 10px">
            Displaying {{first + 1}} - {{first + transactions.length}} of {{totalRecords}}
        </div>
    </ng-template>
</p-table>
